export const GET_specifyConditions = ({ conditions }) => (condition_id) => {
  return conditions.filter((condition) => {
    return condition.id === condition_id
  })
}
